import { BaseFetch } from "../main-model"
export default class RoleModel extends BaseFetch {
    getGenarateUUIDById = (data) =>
    this.directFetch({
      url: "getGenarateUUIDById",
      method: "POST",
      body: JSON.stringify(data),
    })
}